/** 图层树：按 zIndex 倒序，支持选中 / 锁定 / 隐藏 / 上下移层。 */
import { Button, Empty, Space, Tooltip } from 'antd';
import { LockOutlined, UnlockOutlined, EyeOutlined, EyeInvisibleOutlined, ArrowUpOutlined, ArrowDownOutlined } from '@ant-design/icons';
import { getMaterial } from '@h5/materials';
import { selectCurrentPage, useEditorStore } from '../store/store';

export function LayersTab() {
  const page = useEditorStore(selectCurrentPage);
  const selectedIds = useEditorStore((s) => s.ui.selectedIds);
  const { select, updateLayer, reorderLayer } = useEditorStore.getState();
  if (!page) return null;
  const layers = [...page.layers].sort((a, b) => b.style.zIndex - a.style.zIndex);
  if (layers.length === 0) return <Empty description="本页还没有图层" style={{ marginTop: 40 }} />;

  return (
    <div style={{ padding: 8 }}>
      {layers.map((l) => {
        const active = selectedIds.includes(l.id);
        const def = getMaterial(l.type);
        return (
          <div
            key={l.id}
            onClick={(e) => select([l.id], { toggle: e.shiftKey })}
            style={{
              display: 'flex', alignItems: 'center', justifyContent: 'space-between', padding: '6px 8px', marginBottom: 4, borderRadius: 6, cursor: 'pointer',
              border: `1px solid ${active ? '#1677ff' : '#f0f0f0'}`, background: active ? '#e6f4ff' : '#fff', opacity: l.hidden ? 0.5 : 1,
            }}
          >
            <span style={{ fontSize: 13, overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap', flex: 1 }}>
              {typeof def?.icon === 'string' && <span style={{ marginRight: 6 }}>{def.icon}</span>}
              {l.name || def?.name || l.type}
            </span>
            <Space size={0} onClick={(e) => e.stopPropagation()}>
              <Tooltip title="上移一层"><Button size="small" type="text" icon={<ArrowUpOutlined />} onClick={() => reorderLayer(l.id, 'up')} /></Tooltip>
              <Tooltip title="下移一层"><Button size="small" type="text" icon={<ArrowDownOutlined />} onClick={() => reorderLayer(l.id, 'down')} /></Tooltip>
              <Button size="small" type="text" icon={l.locked ? <LockOutlined /> : <UnlockOutlined />} onClick={() => updateLayer(l.id, { locked: !l.locked })} />
              <Button size="small" type="text" icon={l.hidden ? <EyeInvisibleOutlined /> : <EyeOutlined />} onClick={() => updateLayer(l.id, { hidden: !l.hidden })} />
            </Space>
          </div>
        );
      })}
    </div>
  );
}
